import { useDialogControls } from "./useDialogControls.ts";

export const useLoginDialogControls = () => useDialogControls("loginDialog");
